
import { Component, Vue } from "vue-property-decorator";
import { Settings } from "../../../core/services/configService";
import { CrudService } from "../../../core/services/crudService";
import store from "../../../core/store";
import { DateHelper } from "../../../core/helpers/dateHelper";
import { Product } from "@shared/core/interfaces/product";
import { Format } from "@shared/core/helpers/formatHelper";
import ScrollableBanner from "../scrollableBanner.vue";

@Component({
  components: {
    ScrollableBanner,
  },
})
export default class ActivitiesBanner extends Vue {
  activitiesWithParticipants: any[] = [];
  private images: any[] = [];

  async mounted() {
    this.setDefaultImages();
    let url = `${Settings.HostName}/api/publicactivities/list`;
    let data = await new CrudService().httpGet(url);
    if (data == null || !data.ok) {
      console.error("Crash");
      return;
    }
    this.activitiesWithParticipants = data.model.activities.slice(0, 4);
    this.checkScroll();
    window.addEventListener("resize", this.checkScroll);
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.checkScroll);
  }

  private setDefaultImages() {
    const context = require.context(
      "@/images/activities",
      false,
      /\.(png|jpe?g|webp|gif)$/
    );
    this.images = context.keys().map(context);
  }

  getActivityParticipants(activityWithParticipants: any) {
    const participants = Array.isArray(activityWithParticipants.participants)
    ? activityWithParticipants.participants
    : [];

     let result: any[] = [];

    if (participants.length === 0) {
      result = [{}];
    } else if (participants.length < 4) {
      result = [...participants];
    } else {
      result = participants.slice(0, 4);
    }

    return result;
  }

  formatDate(date: string) {
    const d: any = DateHelper.toDate(
      date,
      DateHelper.systemFormat
    );
    
    const sdate = DateHelper.toServerFormat(d);
    return DateHelper.beautifyDate(sdate, true, true, true, false);
  }

  formatHours(date: string) {
    const d: any = DateHelper.toDate(date, DateHelper.systemFormat);
    const hours = d.getHours();
    const minutes = d.getMinutes();
    if (hours === 0 && minutes === 0) {
      return "";
    }
    return DateHelper.extractTime(date);
  }

  getImageActivity(name: string, index: number) {
    if (name !== undefined && name !== "" && name !== null) {
      return store.state.settings.Uploads + "/" + name;
    }
    return this.images[index % this.images.length];
  }

  getImageType(logo: string) {
    if (logo !== undefined && logo !== "" && logo !== null) {
      return store.state.settings.Uploads + "/" + logo;
    }
  }

  buildUrlActivity(activity: any) {
    return `/activity/${activity.id}`;
  }
  checkScroll() {
    this.$nextTick(() => {
      const container = this.$refs
        .activitiesBannerContainer as HTMLElement | null;
      const list = this.$refs.activitiesBannerList as HTMLElement | null;

      if (container && list) {
        const hasHorizontalScroll = list.scrollWidth > container.clientWidth;
        list.style.justifyContent = hasHorizontalScroll
          ? "flex-start"
          : "center";
      }
    });
  }
  private getPrice(pr: Product) {
    if(pr == null) return "";
    const price = store.state.settings.PriceWithTaxes
      ? pr.grossPrice
      : pr.netPrice;
    return Format.formatCurrency(price.toString());
  }

  getBrText(key: string): string {
    const text = this.$t(key) as string;
    const parts = text.split(' ');

    if (parts.length > 1) {
      return `${parts[0]}<br>${parts.slice(1).join(' ')}`;
    }

    return text;
  }

  formatParticipants(activityWithParticipants: any): string {
    const count = activityWithParticipants?.participants?.length ?? 0;
    const max = activityWithParticipants.activity?.maxNumberOfParticipants;

    if (max) {
      return `${count}/${max}`;
    }

    return count;
  }
}
